/** @format */
import { HTMLProps, ReactNode } from 'react';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum CustomSelectAlignment {
    LEFT = 'left',
    RIGHT = 'right',
}

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type CustomSelectProps = Pick<
    HTMLProps<HTMLButtonElement>,
    'className'
> & {
    children: ReactNode;
    'data-testid'?: string;
    closeMenuAriaLabel?: string;
    openMenuAriaLabel?: string;
    label?: string;
    isActive?: boolean;
    isOpen?: boolean;
    onToggleOpen?: () => void;

    /**
     * Handler for when the user clicks outside of the custom select
     */
    onClickOut?: () => void;

    /**
     * The html element ID, must be unique
     */
    id: string;
};

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type CustomSelectSkeletonProps = Pick<
    CustomSelectProps,
    'data-testid' | 'className' | 'isOpen' | 'isActive'
>;

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type StyledCustomSelectProps = Pick<
    CustomSelectProps,
    'isOpen' | 'isActive'
> & {
    alignment: CustomSelectAlignment;
};
